module.exports = __webpack_public_path__ + "static/media/gregg-pollack.aba644d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/gregg-pollack.png
// module id = 240
// module chunks = 0